import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MediumSquareFilledSvg from "@ant-design/icons-svg/es/asn/MediumSquareFilled";
import AntdIcon from "../components/AntdIcon";
var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MediumSquareFilled.displayName = 'MediumSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(MediumSquareFilled);